











































import { Component, Vue, Prop } from "vue-property-decorator";
import DataCard from "../utility/DataCard.vue";
import Debug from "../utility/Debug.vue";
import { UpdateUserDtoFactory } from "@/lib/utility/updateUserDtoFactory";
import { IAdminUser } from "@/models/user.entity";

@Component({ components: { Debug, DataCard } })
export default class ThgBillingSelectionItemUserIdentityData extends Vue {
  @Prop()
  user!: IAdminUser;

  data = this.user;

  locked = true;

  async confirmEdit() {
    if (!this.data) {
      return;
    }

    const updateUserDto = new UpdateUserDtoFactory().createFromIUser(this.data);
    await this.user.updateFromDto(updateUserDto);
  }
}
